<template>
  <div class="text-center py-10 work-in-progress-headline">
    Inca lucram la acest calculator
  </div>
</template>

<script>
export default {
  name: 'MedicalForm'
};
</script>

<style scoped>
.work-in-progress-headline {
  font-size: 28px !important;
}
</style>

